module.exports = __webpack_public_path__ + "img/china_wedding.4be69152.jpg";